import { Typography } from 'shared/ui'
import styles from './styles.module.scss'

type ITotalPlanDataItem = {
  title: string
  value: string
  isTotal?: boolean
  color?: string
}

export const LineItem = ({
  title,
  value,
  isTotal = false,
  color = 'var(--content-primary-primary)',
}: ITotalPlanDataItem) => {
  return (
    <div key={title} className={styles.totalPlanDataLine}>
      <Typography
        ariaLabel={title}
        variant={isTotal ? 'body-lg-medium' : 'body-md-regular'}
        color={'var(--content-primary-primary)'}
      >
        {title}
      </Typography>
      <Typography
        ariaLabel={value}
        variant={isTotal ? 'body-lg-medium' : 'body-md-regular'}
        color={color}
      >
        {value}
      </Typography>
    </div>
  )
}
